import React from 'react';

import { Pressable, Text } from '@rbilabs/universal-components';
import { GestureResponderEvent, StyleSheet, View } from 'react-native';

import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';
import { primitive, spacing } from 'styles/constants';

import { IPaymentMethodAddNewItemOptionProps } from './types';

export const PaymentMethodAddNewItemOption = ({
  text,
  Icon,
  onPress,
  testID,
  selected = false,
  isDisabled = false,
}: IPaymentMethodAddNewItemOptionProps) => {
  const handleOnPress = (e: GestureResponderEvent) => {
    if (!onPress) {
      return;
    }
    if (!selected) {
      logButtonClick({
        attributes: {
          Name: text,
          name: text,
          component: ClickEventComponentNames.BUTTON,
        },
      });
    }
    onPress(e);
  };

  return (
    <Pressable
      onPress={handleOnPress}
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel={text}
    >
      <View style={styles.container}>
        <View style={styles.mainContent}>
          {Icon}
          <Text color={isDisabled ? primitive.$blackOpacity30 : primitive.$bbqBrown}>{text}</Text>
        </View>
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: spacing.$13_5,
    padding: spacing.$2,
    flexDirection: 'column',
    gap: spacing.$2,
    justifyContent: 'center',
  },
  mainContent: {
    gap: spacing.$2,
    flexDirection: 'row',
  },
});
